import React from 'react';
import { Navigate, Outlet, useSearchParams } from 'react-router-dom';
import { ADMIN_HOME, TEMPLATES_ROUTE_V2 } from '../constants/routePathConstants';
import { useUserContext } from '../contexts/UserContext';

// Only honor internal paths (e.g. "/requests"), never external/protocol-relative URLs.
const getSafeReferrer = (referrer) =>
  referrer && referrer.startsWith('/') && !referrer.startsWith('//') ? referrer : null;

const AuthGuard = () => {
  const userCtx = useUserContext();
  const { isGuestLogin } = userCtx;
  const [searchParams] = useSearchParams();

  if (!(userCtx.token && userCtx.refreshToken && userCtx.currentUser)) {
    return <Outlet />;
  }

  const fallback = isGuestLogin ? TEMPLATES_ROUTE_V2 : ADMIN_HOME;
  const referrer = getSafeReferrer(searchParams.get('referrer'));
  return <Navigate to={referrer || fallback} replace />;
};

export default AuthGuard;
